export default {
  newConference: 'New conference',
  dialInNumber: 'Dial-in number',
  host: 'Host',
  participants: 'Participants',
  internationalParticipants: 'International participants',
  internationalNumbersHeader: 'Select International dial-in numbers',
  search: 'Search...',
  inviteWithText: 'Invite by text',
  inviteText: 'Please join the RingCentral conference. \n\nDial-In Numbers: {dialInNumber} \n\n{internationals} \nParticipant Access: {participantCode} \n\nNeed an international dial-in phone number? Please visit http://www.ringcentral.com/conferencing \n\nThis conference call is brought to you by RingCentral Conferencing.',
};
